import { Box } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { colors } from '../../const/colors'

interface TableSearchProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export function TableSearch({
  value,
  onChange,
  placeholder = 'Szukaj…',
}: TableSearchProps) {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 280,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        height: 48,
        px: '18px',
        borderRadius: colors.radiusPill,
        background: colors.surface,
        border: `1px solid ${colors.border3}`,
        '&:focus-within': { borderColor: colors.slate },
      }}
    >
      <SearchIcon sx={{ color: colors.slateLight, fontSize: 18 }} />
      <Box
        component="input"
        data-e2e="table-search"
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        sx={{
          border: 'none',
          outline: 'none',
          background: 'transparent',
          flex: 1,
          fontSize: '14.5px',
          color: colors.textBody,
          fontFamily: 'inherit',
          '&::placeholder': { color: colors.slate },
        }}
      />
    </Box>
  )
}
